
export const TOOLTIP_DELAY_TIME = 2000;
export const IMAGE_BASE_PATH = document.getElementById('hdnStaticFileUrls') ? document.getElementById('hdnStaticFileUrls').value : null;
